<script>
    import { mapActions, mapMutations, mapState } from 'vuex';
    import {Form, Message} from "element-ui";
    import Loader from '~/components/loader/components/loader';
    import PasswordStrength from '~/components/password_strength/components/password_strength';
    import TogglePasswordInput from '~/components/toggle_password_input/components/toggle_password_input';
    import Vue from 'vue';
    import VueButton from '~/components/button/components/button';

    Vue.use(Form);

    export default {
        name: "ps-expired-password-update-form",

        components: {
            Loader,
            PasswordStrength,
            TogglePasswordInput,
            VueButton,
        },

        props: {
            email: {
                type: String,
                default: '',
            },

            redirect_uri: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                rules: {
                    confirmPassword: [
                        {
                            message: 'Passwords do not match',
                            trigger: 'blur',
                            validator: (rule, value, callback) => {
                                value !== this.passwordForm.newPassword ? callback(new Error(rule.message)) : callback();
                            },
                        },
                    ],
                },

                submitButtonText: "Sign In",
            }
        },

        computed: {
            ...mapState('passwordSettings', [
                'loading',
                'passwordForm',
                'passwordRules',
                'passwordResetRules',
                'passwordIsValid',
                'redemptionToken',
                'valid',
            ]),

            isDisabled() {
                return !this.passwordIsValid || this.loading.formPost;
            },
        },

        mounted() {
            this.updatePasswordForm({
                email: this.email,
                redirectUri: this.redirect_uri,
            });

            this.getPasswordRulesFromUserEmail(this.email);
        },

        methods: {
            ...mapActions('passwordSettings', [
                'getPasswordRulesFromUserEmail',
                'postUpdateExpiredPassword',
            ]),

            ...mapMutations('passwordSettings', [
                'updatePasswordIsValid',
                'updateValid',
                'updatePasswordForm',
                'updateLoading',
            ]),

            updatePassword() {
                this.validateForm();

                if (this.valid) {
                    this.updateLoading({
                        formPost: true
                    });

                    this.postUpdateExpiredPassword()
                    .then((response) => {
                        this.submitButtonText = "Logging in ..."
                        window.location.href = response.redirectUri;
                    })
                    .catch((error) => {
                        Message.error(error.message);
                    })
                    .finally(() => {
                        this.updateLoading({
                            formPost: false
                        });

                        this.updateValid(false);
                    });
                }
            },

            validateForm() {
                if (this.$refs.passwordForm) {
                    this.$refs.passwordForm.validate((valid) => {
                        this.updateValid(valid);
                    });
                }
            },
        },
    }
</script>

<template>
    <div>
        <loader :is-loading="loading.passwordRules"></loader>

        <div>
            <el-form
                :model="passwordForm"
                ref="passwordForm"
                :rules="rules"
                @submit.native.prevent
            >
                <toggle-password-input
                    prop-name="password"
                    label-name="Current Password"
                    v-model="passwordForm.password"
                >
                </toggle-password-input>

                <toggle-password-input
                    prop-name="newPassword"
                    label-name="New Password"
                    v-model="passwordForm.newPassword"
                >
                </toggle-password-input>

                <password-strength
                    optional-class="password-compliance"
                    :rules="passwordRules"
                    :value="passwordForm.newPassword"
                    @password-changed="updatePasswordIsValid"
                >
                </password-strength>

                <toggle-password-input
                    prop-name="confirmPassword"
                    label-name="Confirm Password"
                    v-model="passwordForm.confirmPassword"
                >
                </toggle-password-input>
            </el-form>
        </div>

        <div class="login-buttons">
            <vue-button
                class="btn btn-block btn-primary btn-lg login-option-label"
                type="primary"
                :disabled="isDisabled"
                loading-text="Updating password ..."
                :loading="loading.formPost"
                @click="updatePassword"
            >
                {{ submitButtonText }}
            </vue-button>
        </div>
    </div>
</template>
